import { useEffect, useState } from 'react';

// Service
import CashRegisterService from '../../services/cashRegisterService';

const initFilters = {
    pageSize: 100,
    pageNumber: 1,
    active: true
}

const useCashRegisterMovementReasons = ( defaultFilters ) => {
    const [searchResult, setSearchResult] = useState({
        cashRegisterMovementReasons: [],
        totalResults: 0,
        totalPage: 0
    })

    const [filters, setFilters] = useState({ ...initFilters, ...defaultFilters })
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const SearchCashRegisterMovementReasons = async () => {
            setLoading(true);
			await CashRegisterService
                .SearchMovementReasons(filters) 
                .then(res => setSearchResult({
                    cashRegisterMovementReasons: res.values, 
                    totalResults: res.totalResults, 
                    totalPage: res.totalPage
                }))
                .finally(() => setLoading(false));
        }
        
        if(filters !== null)
            SearchCashRegisterMovementReasons();
    }, [filters])

    const chageFilter = ( filters ) =>
        setFilters(state => ({ ...state, ...filters, pageNumber: 1 }))

    const changePageNumber = ( page = 1 ) =>
        setFilters(state => ({ ...state, pageNumber: page }))

    return {
        ...searchResult,
        loading,
        filters,
        chageFilter,
        changePageNumber
    }
}

export default useCashRegisterMovementReasons;